export default class BlogoverviewController {
	constructor() {
		this.dom = {
			container: document.querySelector(".blogOverview div.flex-column"),
			firstList: document.querySelector('.blogOverview div.flex-column ol.masonryContainer'),
			ddlFilter: document.querySelector('#categories')
		};
		this.articles = [];
		this.articlesToShow = [];
		this.itemsPerPage = 10;
		this.currentPage = 1;
		this.currentFilter = '';

		if (this.dom.container != null) {
			this.init();
		}
	}

	init() {
		this.dom.container.querySelectorAll('ol.masonryContainer li.masonryItem').forEach(item => {
			let newItem = item.cloneNode(true);
			this.articles.push(newItem);
			this.articlesToShow.push(newItem);
		});
		
		this.initPaging();
		this.initFilter();
	}

	initFilter() {
		if (this.dom.ddlFilter != null) {
			$('#categories').on('selectric-change', (event, element, selectric) => {
				let selectedValue = $(element).val();

				let curObj = this;
				$(this.dom.container).fadeOut(400 , function () {
					curObj.filterArticles(selectedValue);
				});
			})
		}
	}

	filterArticles(category) {
		if (category != '') {
			this.currentFilter = category;
			this.articlesToShow = [];

			for (var i = 0; i < this.articles.length; i++) {
				if (this.articles[i].dataset.category.split(',').includes(category)) {
					// this.articlesToShow.push(this.articles[i].cloneNode(true));

					const newItem = this.articles[i].cloneNode(true);
					if (app.fader && newItem.querySelector('article')) {
						app.fader.addElement(newItem.querySelector('article'));
					}
					this.articlesToShow.push(newItem);
				}
			}

			this.initPaging();
		} else {	 
			if (this.currentFilter != '') {
				this.articlesToShow = this.articles.map(item => {
					const newItem = item.cloneNode(true);
					if (app.fader && newItem.querySelector('article')) {
						app.fader.addElement(newItem.querySelector('article'));
					}
					return newItem;
				});
				this.initPaging();
			}
		}
	}

	initPaging() {
		//only init paging if the amount of articles are enough
		if (this.articlesToShow.length > this.itemsPerPage) {
			var pageCount = Math.ceil(this.articles.length / this.itemsPerPage);
			while (this.dom.container.firstChild){
				this.dom.container.removeChild(this.dom.container.firstChild);
			}


			for (var currentPage = 1; currentPage <= pageCount; currentPage++) {
				var itemsForPage = this.articlesToShow.slice(this.itemsPerPage * (currentPage - 1), this.itemsPerPage * currentPage);
				
				var list = document.createElement("ol");
				list.classList.add('masonryContainer');
				
				if (currentPage != 1) {
					list.classList.add('hide');
				} 		
				
				this.buildPageList(itemsForPage, list);
				this.dom.container.appendChild(list);

				if (currentPage < pageCount) {
					var button = document.createElement("button");
					button.classList.add('button');
					button.classList.add('js-showMore');
					button.innerHTML = this.dom.container.dataset.buttonTranslation;

					this.dom.container.appendChild(button);
				}

			}
		} else {
			while (this.dom.container.firstChild){
				this.dom.container.removeChild(this.dom.container.firstChild);
			}

			var list = document.createElement("ol");
			list.classList.add('masonryContainer');
			
			this.buildPageList(this.articlesToShow, list);

			this.dom.container.appendChild(list);
		}

		var curObj = this;
		$(this.dom.container).fadeIn(400 , function () {
			curObj.initPagerEvents();
		});
		
	}

	buildPageList(articles, containerElement) {
		articles.forEach(item => {
			containerElement.appendChild(item);
		});
	}

	initPagerEvents() {
		if (document.querySelectorAll('.js-showMore').length) {
			$('.js-showMore').click(function (e) {
				e.preventDefault();

				$(this).hide();
				$(this).next().removeClass('hide');
			});
		}
	}
}